import React from 'react'
import { Button as RebassButton } from 'rebass/styled-components'
import styled from 'styled-components'
import { Plus, ChevronDown, ChevronUp } from 'react-feather'
import { darken, transparentize } from 'polished'
import { RowBetween } from '../Row'
import { StyledIcon } from '..'

const Base = styled(RebassButton)`
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 60px;
  cursor: pointer;
  outline: none;
  font: inherit;
  border: 1px solid transparent;
  outline: none;
  background: transparent;
  border-bottom-right-radius: ${({ open }) => open && '0'};
  border-bottom-left-radius: ${({ open }) => open && '0'};

  border: 1px solid ${({ theme }) => theme.textColor};
  transition: border-color 0.3s;
  :hover {
    border-color: ${({ theme }) => theme.link};
  }
`

const BaseCustom = styled(RebassButton)`
  padding: 16px 12px;
  font-size: 0.825rem;
  font-weight: 400;
  border-radius: 60px;
  cursor: pointer;
  outline: none;
`

const Dull = styled(Base)`
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: black;
  height: 100%;
  font-weight: 400;
  &:hover,
  :focus {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.25);
  }
  &:focus {
    box-shadow: 0 0 0 1pt rgba(255, 255, 255, 0.25);
  }
  &:active {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.25);
  }
`

export default function ButtonStyled({ children, ...rest }) {
  return <Base {...rest}>{children}</Base>
}

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const ButtonLight = styled(Base)`
  min-width: fit-content;
  border-radius: 60px;
  white-space: nowrap;

  a {
    color: ${({ color, theme }) => (color ? darken(0.1, color) : theme.textColor)};
  }
`

export function ButtonDropdown({ disabled = false, children, open, ...rest }) {
  return (
    <ButtonFaded {...rest} disabled={disabled} ope={open}>
      <RowBetween>
        <div style={{ display: 'flex', alignItems: 'center' }}>{children}</div>
        {open ? (
          <StyledIcon>
            <ChevronUp size={24} />
          </StyledIcon>
        ) : (
          <StyledIcon>
            <ChevronDown size={24} />
          </StyledIcon>
        )}
      </RowBetween>
    </ButtonFaded>
  )
}

export const ButtonDark = styled(Base)`
  color: ${({ theme }) => theme.textColor};
  width: fit-content;
  border-radius: 60px;
  white-space: nowrap;
  font: inherit;
  border: 1px solid ${({ theme }) => theme.textColor};
  transition: border-color 0.3s;
  :hover {
    border-color: ${({ theme }) => theme.green};
  }
`

export const ButtonFaded = styled(Base)`
  background-color: ${({ theme }) => theme.advancedBG};
  color: (255, 255, 255, 0.5);
  white-space: nowrap;

  :hover {
    opacity: 0.5;
  }
`

export function ButtonPlusDull({ disabled, children, ...rest }) {
  return (
    <Dull {...rest}>
      <ContentWrapper>
        <Plus size={16} />
        <div style={{ display: 'flex', alignItems: 'center' }}>{children}</div>
      </ContentWrapper>
    </Dull>
  )
}

export function ButtonCustom({ children, bgColor, color, ...rest }) {
  return (
    <BaseCustom bg={bgColor} color={color} {...rest}>
      {children}
    </BaseCustom>
  )
}

export const OptionButton = styled.div`
  font-weight: 500;
  font-size: 14px;
  width: fit-content;
  white-space: nowrap;
  padding: 8px 20px;
  border-radius: 60px;
  background: ${({ theme }) => theme.green};
  /* border: 1px solid ${({ theme }) => theme.optionBorder}; */
  color: ${({ theme }) => theme.dark};
  transition: border-color 0.3s;
  :hover {
    cursor: ${({ disabled }) => !disabled && 'pointer'};
  }
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`

export const RoundedButton = styled(OptionButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  color: ${({ theme }) => theme.dark};
  /* border: 1px solid ${({ theme }) => theme.optionBorder}; */
  background: ${({ theme }) => theme.green};
`

export const BaseBtn = styled(RebassButton)`
  padding: '18px';
  width: '100%';
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  font-family: inherit;
  border-radius: 40px;
  outline: none;
  border: none;
  color: white;
  text-decoration: none;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
  position: relative;
  z-index: 1;
  &:disabled {
    cursor: auto;
  }

  > * {
    user-select: none;
  }
`
